import styled from "styled-components";

export const Container = styled.div``;

export const Header = styled.div``;

export const FeedList = styled.ul``;
